<p-toast />

<div class="page-title">
  {{ isEditing ? 'Editar Ciclo - Chame & Ganhe' : 'Novo Ciclo - Chame & Ganhe' }}
</div>

<p-card>
  <form [formGroup]="form" class="form-b4a" (submit)="submit()">
    <span class="p-float-label">
      <p-calendar
        inputId="referenceMonth"
        formControlName="referenceMonth"
        view="month"
        dateFormat="mm/yy"
        [showIcon]="true"
        [readonlyInput]="true"
        [ngClass]="{ 'ng-invalid ng-dirty': invalidControl('referenceMonth') }"
        (onSelect)="updateCanSubmit()"
      />
      <label for="referenceMonth">Mês de referência *</label>
    </span>

    <div class="full-w" formArrayName="slots">
      <p-fieldset
        *ngFor="let slot of slotStates; let si = index"
        [formGroupName]="si"
        [legend]="slot.label"
      >
        <p>
          {{ slot.products.length }} produto{{ slot.products.length === 1 ? '' : 's' }}
        </p>

        <div class="buttons">
          <p-button
            label="Adicionar produto"
            icon="pi pi-plus"
            [text]="true"
            size="small"
            type="button"
            (onClick)="addProduct(si)"
          />
        </div>

        <div formArrayName="products">
          <p-card
            *ngFor="let state of slot.products; let pi = index"
            [formGroupName]="pi"
          >
            <span class="form-b4a">
              <img
                *ngIf="state.imageUrl"
                [src]="state.imageUrl"
                [alt]="state.productName"
                width="40"
                height="40"
              />

              <span *ngIf="state.productName">
                {{ state.productName }}
              </span>
              <span *ngIf="state.loading">
                Buscando produto...
              </span>
              <span *ngIf="!state.loading && !state.productName">
                Nenhum produto selecionado
              </span>
              <small *ngIf="state.error" class="error">
                {{ state.error }}
              </small>

              <span class="p-float-label">
                <input
                  pInputText
                  [id]="'sku-' + si + '-' + pi"
                  type="number"
                  formControlName="sku"
                  [ngClass]="{ 'ng-invalid ng-dirty': invalidSku(si, pi) }"
                  (input)="onSkuInput(si, pi)"
                  (blur)="onSkuBlur(si, pi)"
                />
                <label [for]="'sku-' + si + '-' + pi">SKU Millenium *</label>
              </span>

              <p-button
                icon="pi pi-trash"
                [text]="true"
                size="small"
                severity="danger"
                type="button"
                [disabled]="state.removeDisabled"
                (onClick)="removeProduct(si, pi)"
                pTooltip="Remover produto"
              />
            </span>
          </p-card>
        </div>
      </p-fieldset>
    </div>

    <div class="buttons">
      <p-button
        label="Cancelar"
        severity="secondary"
        [outlined]="true"
        type="button"
        (onClick)="cancel()"
      />
      <p-button
        [label]="submitLabel"
        icon="pi pi-check"
        type="submit"
        [disabled]="!canSubmit"
      />
    </div>
  </form>
</p-card>
